import { ResourceData, ResourceCity } from './Models/resourceClasses';
import { get, getIbeHost } from './Utilities/fetchUtilities';
import eventBus from './eventBus';
import { getCacheItem, setCacheItem } from './cache';

declare let Promise: any;//Tricking ts linter from thinking Promise.all is bad

const resourceEvent = "resourcesLoaded";

export function getResourceData(allowCached: Boolean = true, host: string = "", params: string = ""): Promise<ResourceData> {
    const cacheName = "resourcePromise" + params,
        cached = getCacheItem<Promise<ResourceData>>(cacheName),
        url = host + "/F9Sessionless/Resources" + params;

    if (!cached || !allowCached) {
        eventBus.dispatch("dataStarted", { data: "resourceData" });

        return setCacheItem(cacheName, get(url)
            .then(response => response.json())
            .then(json => {
                let data = new ResourceData(json);
                SanitizeCode(data);
                eventBus.dispatch(resourceEvent, { data });

                return data;
            }));
    }

    return cached;
}

export function getAvatars(allowCached: Boolean = true, host: string = ""): Promise<any[]> {
    const cacheName = "avatarPromise",
        cached = getCacheItem<Promise<any>>(cacheName),
        url = host + "/F9Sessionless/Avatars";

    if (!cached || !allowCached) {
        eventBus.dispatch("dataStarted", { data: "avatarData" });

        return setCacheItem(cacheName, get(url)
            .then(response => response.json()));
    }

    return cached;
}

export function getHotelCities(allowCached: Boolean = true, host: string = ""): Promise<ResourceCity[]> {
    const cacheName = "citiesPromise",
        cached = getCacheItem<Promise<ResourceCity[]>>(cacheName),
        url = host + "/F9Extras/GetHotelCities";

    if (!cached || !allowCached) {
        eventBus.dispatch("dataStarted", { data: "citiesData" });

        return setCacheItem(cacheName, get(url)
            .then(response => response.json())
            .then(cities => cities.sort((a, b) => ('' + a.name).localeCompare(b.name))));
    }

    return cached;
}

export function attachToResourceEvent(func: EventListenerOrEventListenerObject) {
    eventBus.attach(resourceEvent, func);
}

export function detachFromResourceEvent(func: EventListenerOrEventListenerObject) {
    eventBus.detach(resourceEvent, func);
}

let ddCost = 0;

export function getDiscountDenPrice(): Promise<Number> {
    const localUrl = getIbeHost() + '/resource/DiscountDenPrice';
    const defaultDDPrice = 99.99;

    if (ddCost) {
        return new Promise(() => ddCost);
    }

    return get(localUrl)
        .then(x => x.json())
        .then(data => {
            if (data) {
                return ddCost = data;
            } else {
                return ddCost = defaultDDPrice;
            }
        })
        .catch(error => {
            return ddCost = defaultDDPrice;
        });
}

let kffEnabled = null;

export function getKffEnabled(): Promise<Boolean> {
    const localUrl = getIbeHost() + '/resource/IsKffEnabled';

    if (kffEnabled !== null) {
        return new Promise(() => kffEnabled);
    }

    return get(localUrl)
        .then(x => x.json())
        .then(data => {
            if (data) {
                return kffEnabled = data;
            } else {
                return kffEnabled = false;
            }
        })
        .catch(error => {
            return kffEnabled = false;
        })
}

function SanitizeCode(data) {
    data.usStates.map((item) => {
        var info = item.code.split("|");
        item.code = info[info.length - 1];
    });
}
